import { render } from "./invoice-pdf.vue?vue&type=template&id=c06bd1c2&scoped=true"
import script from "./invoice-pdf.vue?vue&type=script&lang=js"
export * from "./invoice-pdf.vue?vue&type=script&lang=js"

import "./invoice-pdf.vue?vue&type=style&index=0&id=c06bd1c2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c06bd1c2"],['__file',"src/views/pages/main/invoice/invoice-pdf.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c06bd1c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c06bd1c2', __exports__)) {
    console.log('reload')
    api.reload('c06bd1c2', __exports__)
  }
  
  module.hot.accept("./invoice-pdf.vue?vue&type=template&id=c06bd1c2&scoped=true", () => {
    console.log('re-render')
    api.rerender('c06bd1c2', render)
  })

}


export default __exports__